function runDataCheck() {
    const windowLocation = window.location.href;
    const itemsToCheck = document.querySelectorAll('.run_data_check');

    if (windowLocation.includes('filter=in-stock') || windowLocation.includes('filter.v.availability=1')) {
        document.body.classList.add('filtered-in-stock');
        document.body.classList.remove('not-filtered-in-stock');
        
        itemsToCheck.forEach(function (element) {
            if (element.dataset.quantity === 'null' || parseInt(element.dataset.quantity) <= 0 || element.dataset.status == 'out-of-stock') {
                element.classList.add('disabled');
                element.classList.remove('in-stock');
            } else {
                element.classList.remove('disabled');
                element.classList.add('in-stock');
            }
        });
    } else {
        document.body.classList.remove('filtered-in-stock');
        document.body.classList.add('not-filtered-in-stock');
    }
}

document.addEventListener('DOMContentLoaded', runDataCheck);